import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ToggleComponent),
    },
  ],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
})
export class ToggleComponent implements ControlValueAccessor {
  onChange!: (value: boolean) => void;

  onTouched!: () => void;

  @Input() value!: boolean;

  @Input() disabled!: boolean;

  @Input() cssClass!: string;

  @Output() valueChange = new EventEmitter<boolean>();

  toggle() {
    if (!this.disabled) {
      this.value = !this.value;
      this.valueChange.emit(this.value);
      if (this.onChange) {
        this.onChange(this.value);
        this.onTouched();
      }
    }
  }

  writeValue(obj: boolean): void {
    this.value = obj;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
